import React, { useEffect } from "react";
import {
  PdfTest,
  getPdfProfidatenTest,
  PdfSourceInfo,
} from "./PdfProfiGenerator";
import { PdfViewHome } from "./PdfViewHome";
import { Button, Row, Col, Space, Collapse } from "antd";
import ReactPDF, {
  Document,
  Page,
  Text,
  PDFViewer,
  BlobProvider,
  pdf,
} from "@react-pdf/renderer";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { infoSet, infoClear } from "../Redux/infoSlice";
import { dataSet, dataClear } from "../Redux/dataSlice";
import { pdfSet, pdfClear } from "../Redux/pdfSlice";

export const PdfTestHome = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(dataSet("Neue Daten"));
    dispatch(infoSet("Hier neue Information"));
  }, []);

  const data = useSelector((state) => state.data.value);
  const info = useSelector((state) => state.info.value);

  const handleClick = (event) => {
    const buttonId = event.currentTarget.getAttribute("data-id");
    //console.log("Button geklickt:", buttonId);
    let pdfDaten = null;
    switch (parseInt(buttonId)) {
      case 1:
        pdfDaten = getPdfProfidatenTest(50, 10, 2);
        //console.log("lange Daten gesetzt");
        break;
      default:
        pdfDaten = {
          // HomeLink: ["PdfTestHome", "/PdfTestHome"],
          PdfHead: {
            fixed: true,
            text: ["PDF Generator", "Profimode", "1.5.2024"],
          },
          PdfHeadDatenArray: [
            { texte: [["Willkommen in der wirklichen Welt"]] },
          ],
          PdfDatenArray: [{ texte: [["A", "B", "C"], ["X", "Y"], ["Z"]] }],
          PdfFooterText: {
            textLink: "Powered by Aconsoft",
            textRechts: "Ing.Christian Pohanka",
          },
        };
        //console.log("kurze Daten gesetzt");
        break;
    }
    pdfDaten.HomeLink = ["PdfTestHome", "/PdfTestHome"];
    dispatch(pdfSet(pdfDaten));
    /* Alternative in der Session speichern und dann im eigenen Tab öffnen
    window.sessionStorage.setItem("pdf", JSON.stringify(pdfDaten));
    window.open('/pdfhome', '_pdfprint');
    */
    navigate("/pdfViewhome");
  };

  const CodeSnippet = ({ code }) => {
    return (
      <pre>
        <code
          dangerouslySetInnerHTML={{ __html: code }}
          style={{ color: "red" }}
        />
      </pre>
    );
  };
  // style={{ alignContent: "center", textAlign: "center" }}
  const collapseItems = PdfSourceInfo.map((item, index) => ({
    key: String(index), // Verwende den Index als Key, um eindeutige Keys sicherzustellen
    label: item.head,
    children: <CodeSnippet code={item.code} />,
  }));
  
 
    
  
  
  return (
    <>
      <div className="page">
        <Row key="1" style={{ margin: 5 }}>
          <Space size={10}>
            <Col span={12} key="c1">
              <Button key="9a" data-id="1" onClick={handleClick}>
                Pdf Test mit langen Daten
              </Button>
            </Col>

            <Col span={12} key="c3">
              <Button key="9b" data-id="2" onClick={handleClick}>
                Pdf Test mit kurzen Daten
              </Button>
            </Col>
          </Space>
        </Row>

        <Row style={{ margin: 5 }}>
          <Col span={24}>
          <Collapse size="small" items={collapseItems} />
          </Col>
        </Row>
      </div>
    </>
  );
};
